import Vue from "vue";
import appConfigurationService from "@/Services/AppConfigurationService";

const state = () => ({
  hikvisionEnabled: false,
  notifiqTabEnabled: false,
  notifiqLancamentoEnabled: false,
  loading: false,
});

const mutations = {
  setLoading(state, loading) {
    Vue.set(state, "loading", loading);
  },
  setHikvisionEnabled(state, enabled) {
    Vue.set(state, "hikvisionEnabled", enabled);
  },
  setNotifiqTabEnabled(state, enabled) {
    Vue.set(state, "notifiqTabEnabled", enabled);
  },
  setNotifiqLancamentoEnabled(state, enabled) {
    Vue.set(state, "notifiqLancamentoEnabled", enabled);
  },
};

const actions = {
  async fetchHikvisionStatus({ commit }) {
    commit("setLoading", true);
    try {
      const response = await appConfigurationService.getHikvisionStatus();
      commit("setHikvisionEnabled", Boolean(response.enabled));
    } catch (error) {
      commit("setHikvisionEnabled", false);
    } finally {
      commit("setLoading", false);
    }
  },
  async toggleHikvision({ commit }, enabled) {
    commit("setLoading", true);
    try {
      const response = await appConfigurationService.toggleHikvision(enabled);
      commit("setHikvisionEnabled", Boolean(response.enabled));
      return response;
    } finally {
      commit("setLoading", false);
    }
  },
  async fetchNotifiqTabStatus({ commit }) {
    commit("setLoading", true);
    try {
      const response = await appConfigurationService.getNotifiqTabStatus();
      commit("setNotifiqTabEnabled", Boolean(response.enabled));
    } catch (error) {
      commit("setNotifiqTabEnabled", false);
    } finally {
      commit("setLoading", false);
    }
  },
  async toggleNotifiqTab({ commit }, enabled) {
    commit("setLoading", true);
    try {
      const response = await appConfigurationService.toggleNotifiqTab(enabled);
      commit("setNotifiqTabEnabled", Boolean(response.enabled));
      return response;
    } finally {
      commit("setLoading", false);
    }
  },
  async fetchNotifiqLancamentoStatus({ commit }) {
    commit("setLoading", true);
    try {
      const response = await appConfigurationService.getNotifiqLancamentoStatus();
      commit("setNotifiqLancamentoEnabled", Boolean(response.enabled));
    } catch (error) {
      commit("setNotifiqLancamentoEnabled", false);
    } finally {
      commit("setLoading", false);
    }
  },
  async toggleNotifiqLancamento({ commit }, enabled) {
    commit("setLoading", true);
    try {
      const response = await appConfigurationService.toggleNotifiqLancamento(enabled);
      commit("setNotifiqLancamentoEnabled", Boolean(response.enabled));
      return response;
    } finally {
      commit("setLoading", false);
    }
  },
};

const getters = {
  hikvisionEnabled: (state) => state.hikvisionEnabled,
  notifiqTabEnabled: (state) => state.notifiqTabEnabled,
  notifiqLancamentoEnabled: (state) => state.notifiqLancamentoEnabled,
  loading: (state) => state.loading,
};

const namespaced = true;

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced,
};
